import { useEffect } from 'react';

export const usePageTitle = (title) => {
  useEffect(() => {
    document.title = title ? `${title} — 617Reach` : '617Reach';
    return () => { document.title = '617Reach'; };
  }, [title]);
};
